import { render, staticRenderFns } from "./sendPageMSG.vue?vue&type=template&id=584f5a5f&"
import script from "./sendPageMSG.vue?vue&type=script&lang=js&"
export * from "./sendPageMSG.vue?vue&type=script&lang=js&"
import style0 from "./sendPageMSG.vue?vue&type=style&index=0&id=584f5a5f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports